import api from './api';
import { ActivityLogPage, ActivityQuery } from '../types';

export const activityService = {
  getActivity: async (query: ActivityQuery = {}): Promise<ActivityLogPage> => {
    const params: Record<string, string | number> = {};
    if (query.action) params.action = query.action;
    if (query.username) params.username = query.username;
    if (query.from) params.from = query.from;
    if (query.to) params.to = query.to;
    if (query.page != null) params.page = query.page;
    if (query.size != null) params.size = query.size;

    const response = await api.get('/activity', { params });
    return response.data;
  },
};

export default activityService;
